export const QUEUE_VIEW = {
  PENDING: 'pending',
  COMPLETED: 'completed',
};

export const SORT_ORDER = {
  ASC: 'asc',
  DESC: 'desc',
};

export const QUEUE_COLUMN = {
  CUSTOMER: 'CUSTOMER',
  CUSTOMER_ID: 'CUSTOMER_ID',
  OFFER_ACCEPTED: 'OFFER_ACCEPTED',
  AGE: 'AGE',
  CONTACT_INFO: 'CONTACT_INFO',
  COMPLETED_AT: 'COMPLETED_AT',
  OPERATOR: 'OPERATOR',
  PRICE: 'PRICE',
  STATUS: 'STATUS',
  ATTEMPTS: 'ATTEMPTS',
  ACTIONS: 'ACTIONS',
};

export const LOAD_SCOPE = {
  ALL: 'all',
  VIEW: 'view',
};

export const QUEUE_PAGE_HEADER = 'Onboarding Queue';

export const VIEW_TAB_LABELS = {
  [QUEUE_VIEW.PENDING]: 'Pending Welcome Call',
  [QUEUE_VIEW.COMPLETED]: 'Welcome Call Complete',
};

export const QUEUE_COLUMNS = {
  [QUEUE_VIEW.PENDING]: [
    { key: QUEUE_COLUMN.CUSTOMER, label: 'Customer', sortable: false },
    { key: QUEUE_COLUMN.CUSTOMER_ID, label: 'Customer ID', sortable: false },
    { key: QUEUE_COLUMN.OFFER_ACCEPTED, label: 'Offer Accepted', sortable: true },
    { key: QUEUE_COLUMN.AGE, label: 'Age', sortable: false },
    { key: QUEUE_COLUMN.CONTACT_INFO, label: 'Contact Info', sortable: false },
    { key: QUEUE_COLUMN.PRICE, label: 'Price', sortable: false },
    { key: QUEUE_COLUMN.STATUS, label: 'Status', sortable: false },
    { key: QUEUE_COLUMN.ATTEMPTS, label: 'Attempts', sortable: false },
    { key: QUEUE_COLUMN.ACTIONS, label: '', sortable: false },
  ],
  [QUEUE_VIEW.COMPLETED]: [
    { key: QUEUE_COLUMN.CUSTOMER, label: 'Customer', sortable: false },
    { key: QUEUE_COLUMN.CUSTOMER_ID, label: 'Customer ID', sortable: false },
    { key: QUEUE_COLUMN.COMPLETED_AT, label: 'Completed', sortable: true },
    { key: QUEUE_COLUMN.OPERATOR, label: 'Operator', sortable: false },
    { key: QUEUE_COLUMN.PRICE, label: 'Price', sortable: false },
    { key: QUEUE_COLUMN.STATUS, label: 'Status', sortable: false },
    { key: QUEUE_COLUMN.ATTEMPTS, label: 'Attempts', sortable: false },
    { key: QUEUE_COLUMN.ACTIONS, label: '', sortable: false },
  ],
};

export const VIEW_SORT_KEY = {
  [QUEUE_VIEW.PENDING]: 'offerAcceptedDate',
  [QUEUE_VIEW.COMPLETED]: 'completedAt',
};

export const VIEW_DEFAULT_ORDER = {
  [QUEUE_VIEW.PENDING]: SORT_ORDER.ASC,
  [QUEUE_VIEW.COMPLETED]: SORT_ORDER.DESC,
};

export const DATE_FILTER_LABELS = {
  [QUEUE_VIEW.PENDING]: 'Offer Accepted',
  [QUEUE_VIEW.COMPLETED]: 'Completed',
};

export const STATUS_LABELS = {
  PENDING: 'Pending',
  ACCEPTED: 'Accepted',
  DECLINED: 'Declined',
};

export const OPERATOR_ACTOR_PREFIX = 'OFFER_ACCEPTED:';

export const SYSTEM_ACTOR = 'SYSTEM';

export const QUEUE_PAGE_SIZE = 20;

export const VALUE_PLACEHOLDER = '—';

export const QUEUE_EMPTY_MESSAGE = 'The onboarding queue is empty.';

export const QUEUE_NO_MATCH_MESSAGE = 'No records match these filters.';

export const QUEUE_ERROR_FALLBACK = 'Failed to load the onboarding queue. '
  + 'Please try again or contact support.';

export const QUEUE_REFUSED_MESSAGE = 'Access to the onboarding queue was refused. '
  + 'This page requires the admin role.';

export const QUEUE_DATE_FORMAT = 'YYYY-MM-DD';

export const COVERAGE_TIME_ZONE = 'America/New_York';

export const WALL_CLOCK_PARSE_FORMAT = 'YYYY-MM-DDTHH:mm:ss';

export const WALL_CLOCK_DISPLAY_FORMAT = 'YYYY-MM-DD HH:mm';

export const QUEUE_STATUS = {
  PENDING: 'PENDING',
  ACCEPTED: 'ACCEPTED',
  DECLINED: 'DECLINED',
};

export const ONBOARDING_REASON = {
  CLIENT_UNREACHABLE: 'CLIENT_UNREACHABLE',
  MISUNDERSTANDING_OF_PRODUCT: 'MISUNDERSTANDING_OF_PRODUCT',
  INELIGIBLE_FOR_PRODUCT: 'INELIGIBLE_FOR_PRODUCT',
  OFFER_CANCELLED: 'OFFER_CANCELLED',
  OTHER: 'OTHER',
};

export const ONBOARDING_REASON_LABELS = {
  [ONBOARDING_REASON.CLIENT_UNREACHABLE]: 'Client Unreachable',
  [ONBOARDING_REASON.MISUNDERSTANDING_OF_PRODUCT]: 'Misunderstanding of Product',
  [ONBOARDING_REASON.INELIGIBLE_FOR_PRODUCT]: 'Ineligible for Product',
  [ONBOARDING_REASON.OFFER_CANCELLED]: 'Offer Cancelled',
  [ONBOARDING_REASON.OTHER]: 'Other',
};

export const REASON_OPTIONS = Object.values(ONBOARDING_REASON).map(reason => ({
  key: reason,
  value: reason,
  text: ONBOARDING_REASON_LABELS[reason],
}));

export const EDIT_STATUS_OPTIONS = [QUEUE_STATUS.PENDING, QUEUE_STATUS.DECLINED].map(status => ({
  key: status,
  value: status,
  text: STATUS_LABELS[status],
}));

export const NOTE_MAX_LENGTH = 2000;

export const QUEUE_ACTION = {
  ACTIVATE: 'ACTIVATE',
  OPT_OUT: 'OPT_OUT',
  EDIT_STATUS: 'EDIT_STATUS',
  NOTES: 'NOTES',
};

export const ROW_ACTION_LABELS = {
  [QUEUE_ACTION.ACTIVATE]: 'Activate Subscription',
  [QUEUE_ACTION.OPT_OUT]: 'Customer Opted Out',
  [QUEUE_ACTION.EDIT_STATUS]: 'Edit Status',
  [QUEUE_ACTION.NOTES]: 'Notes',
};

export const ROW_ACTIONS = {
  [QUEUE_VIEW.PENDING]: [QUEUE_ACTION.ACTIVATE, QUEUE_ACTION.OPT_OUT, QUEUE_ACTION.NOTES],
  [QUEUE_VIEW.COMPLETED]: [
    QUEUE_ACTION.EDIT_STATUS,
    QUEUE_ACTION.NOTES,
    QUEUE_ACTION.ACTIVATE,
  ],
};

export const ACTIVATE_DISABLED_REASON = 'This record is already accepted.';

export const EDIT_STATUS_DISABLED_REASON = 'An accepted record cannot be edited — '
  + 'the subscription already exists.';

export const DISABLED_REASONS = {
  [QUEUE_ACTION.ACTIVATE]: ACTIVATE_DISABLED_REASON,
  [QUEUE_ACTION.EDIT_STATUS]: EDIT_STATUS_DISABLED_REASON,
};

export const ACTIVATE_DIALOG_HEADER = 'Activate Subscription';

export const ACTIVATE_IRREVERSIBLE_NOTICE = 'This creates the seller subscription and cannot be undone from this queue.';

export const ACTIVATE_COVERAGE_NOTICE = 'Coverage starts on';

export const ACTIVATE_CONFIRM_LABEL = 'Activate';

export const ACTIVATE_SUCCESS_MESSAGE = 'The record was activated.';

export const NO_AGREED_PRICE_MESSAGE = 'This record carries no agreed price, so it cannot be activated. '
  + 'The offer has to be re-accepted with a price.';

export const OPT_OUT_DIALOG_HEADER = 'Customer Opted Out';

export const OPT_OUT_NO_SUBSCRIPTION_NOTICE = 'No subscription record is created on this path.';

export const OPT_OUT_CONFIRM_LABEL = 'Record Opt-Out';

export const OPT_OUT_SUCCESS_MESSAGE = 'The record was closed as opted out.';

export const EDIT_STATUS_DIALOG_HEADER = 'Edit Status';

export const EDIT_STATUS_CONFIRM_LABEL = 'Save Status';

export const EDIT_STATUS_SUCCESS_MESSAGE = 'The record status was updated.';

export const REASON_FIELD_LABEL = 'Reason';

export const REASON_OTHER_FIELD_LABEL = 'Reason detail';

export const REASON_REQUIRED_MESSAGE = 'A reason is required.';

export const REASON_OTHER_REQUIRED_MESSAGE = 'A reason detail is required when the reason is Other.';

export const NOTES_DIALOG_HEADER = 'Welcome Call Log';

export const NOTES_EMPTY_MESSAGE = 'No call attempts have been logged for this record.';

export const NOTES_LOADING_MESSAGE = 'Loading the call log...';

export const NOTE_FIELD_LABEL = 'Log a call attempt';

export const NOTE_CONFIRM_LABEL = 'Add Note';

export const NOTE_REQUIRED_MESSAGE = 'A note is required.';

export const NOTE_TOO_LONG_MESSAGE = `A note cannot exceed ${NOTE_MAX_LENGTH} characters.`;

export const NOTE_SUCCESS_MESSAGE = 'The call attempt was logged.';

export const DIALOG_CANCEL_LABEL = 'Cancel';
